module.exports = __webpack_public_path__ + "img/Group.111af2b3.svg";